const mainContainer = {
  paddingTop: 2,
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
};

const cardPadding = {
  padding: 2
}

export default {mainContainer, cardPadding}